import { Component, OnInit } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';

@Component({
  selector: 'app-pricing',
  templateUrl: './pricing.component.html',
  styleUrls: ['./pricing.component.scss']
})
export class PricingComponent implements OnInit {
  constructor(
    private meta: Meta,
    private title: Title
  ) {}

  ngOnInit() {
    this.title.setTitle('Pricing - Talespinner.io | Flexible AI-Powered Storytelling');
    this.meta.updateTag({ name: 'description', content: 'Discover Talespinner.io\'s flexible, usage-based pricing. Pay only for the AI assistance you use with our Quill system. Start writing your story today!' });
    this.meta.updateTag({ name: 'keywords', content: 'Talespinner pricing, AI writing costs, flexible pricing, pay-as-you-go, Quill system, storytelling platform' });
  }
}
